import { IChatModel } from "redux/actions";
import { FormattedMessage } from "react-intl";
import { useWindowSize } from "hooks/useWindowSize";
interface IProps {
    chatModel: IChatModel;
}

const capitalizeWords = (text: string) => {
  return text
    .replace(/-/g, " ") // Replace hyphens with spaces
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
export const BestForTages = ({ chatModel }: IProps) => {

    const tasksString = chatModel?.attributes?.supported_downstream_tasks || "";
    const tasks = tasksString.split(",").slice(0, 3); // get first 3 tasks
    const { width } = useWindowSize();
    return (
        <div className="flex flex-col gap-2">
            <div className={`text-[#737373] dark:text-[rgba(255,255,255,0.6)] font-inter font-medium  ${width<=576 ? "text-[12px]": "text-[14px]"}`}><FormattedMessage id="gptmodel.bestfor" /></div>
            <div className="flex overflow-x-auto whitespace-nowrap gap-2">
                {tasks.map((task, index) => (
                    <button
                        key={index}
                        className={`bg-[#EDF4FE] px-[6px] py-[2px] rounded-[4px] text-[#64748B] font-inter font-medium  ${width<=576 ? "text-[12px]": "text-[14px]"}`}
                    >
                        {capitalizeWords(task.trim())}
                    </button>
                ))}
            </div>
        </div>
    );
};
